import {
  handleSetUrlSearchParams,
  SUPPORT_TICKET_PARAM,
  SupportTicketType,
} from '@vgrubs/components';
import { useSearchParams } from 'react-router-dom';
import { SupportTicketTab } from '../helpers/supportTicketLabels';

/**
 * Everything about what the page is showing lives in the URL.
 *
 * Same reasoning as the chat inbox: a tab and a filter are where somebody is,
 * and a colleague being sent "the refund one" has to arrive at it. The open
 * ticket is a param rather than a route so the list underneath keeps its place.
 */
export const useSupportTicketFilters = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  // Absent means Open: the tab everyone starts on writes no param.
  const tab = (searchParams.get('tab') as SupportTicketTab) || 'open';
  const type = (searchParams.get('type') as SupportTicketType) || null;
  const locationParam = searchParams.get('locationId');
  const locationId = locationParam ? Number(locationParam) : null;
  /* Carried beside the id so the picker can show a name on a cold load without
     fetching the location just to label its own button. */
  const locationName = searchParams.get('locationName');

  const ticketParam = searchParams.get(SUPPORT_TICKET_PARAM);
  const ticketId = ticketParam ? Number(ticketParam) : null;

  const set = (key: string, value: string) =>
    handleSetUrlSearchParams(key, value, setSearchParams);

  return {
    tab,
    type,
    locationId,
    locationName,
    ticketId,
    setTab: (next: SupportTicketTab) => set('tab', next === 'open' ? '' : next),
    setType: (next: string) => set('type', next),
    setLocation: (id: number | null, name?: string | null) => {
      set('locationId', id === null ? '' : String(id));
      set('locationName', id === null ? '' : name || '');
    },
    openTicket: (id: number | null) =>
      set(SUPPORT_TICKET_PARAM, id === null ? '' : String(id)),
  };
};
